import {useEffect, useState} from 'react';
import CommonContainer from '../../../common/Container/CommonContainer';
import {useManagementsOverview} from '../model/query/ManagementOverview.query';
import OverviewCard from './OverviewCard/OverviewCard';
import * as S from './ManagementOverview.style';
import {MANAGEMENT_OVERVIEW} from '../ManagementDashboard.attribute';

export default function ManagementOverview() {
    const { data, isLoading } = useManagementsOverview();

    const [dataMap, setDataMap] = useState(new Map());
    useEffect(() => {
        if (data) {
            setDataMap(new Map(Object.entries(data)));
        }
    }, [data]);

    const handleClickOverview = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <CommonContainer>
            <S.OverviewContainer>
                {MANAGEMENT_OVERVIEW.map((data) => {
                    const count = dataMap.get(data.value) || 0;
                    const showAlert = dataMap.get(data.alertKey) || false;
                    return <OverviewCard key={data.value} data={data} count={count} showAlert={showAlert} onClick={() => handleClickOverview(data.id)} />;
                })}
            </S.OverviewContainer>
        </CommonContainer>
    );
}
